const features = [
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全部国产影片采用高清编码技术，画质清晰细腻，色彩还原真实，带给您影院级的视觉享受。',
    color: 'primary',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '全网CDN加速节点覆盖，91国产免费视频点击即播不缓冲，告别卡顿等待，观影体验流畅丝滑。',
    color: 'accent',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '编辑团队每日精选50+部国产影片入库，91传媒视频在线资源持续扩充，内容永不过时。',
    color: 'secondary',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '电脑、平板、手机全终端自适应播放，随时随地畅享国产视频在线观看免费服务。',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; icon: string; border: string }> = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-500', border: 'border-primary-200/50' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-500', border: 'border-accent-200/50' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-500', border: 'border-secondary-200/50' },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            为什么数百万观众选择91免费视频网站？四大核心优势让您的观影体验与众不同
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat) => {
            const c = colorMap[feat.color];
            return (
              <div
                key={feat.title}
                className={`p-5 md:p-6 rounded-xl bg-background-50 border ${c.border} transition-all duration-200 hover:-translate-y-0.5`}
              >
                <div className={`w-11 h-11 rounded-lg ${c.bg} flex items-center justify-center mb-4`}>
                  <i className={`${feat.icon} ${c.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}